module.exports = __webpack_public_path__ + "img/power-cut.dadf23c2.svg";